import React, { FC } from 'react';

import { REVERSED_LOGIC } from '@/app/constants/dictionaries/TankLogic';
import Translator from '../../../helpers/TranslationHelper';
import { IFuelTank } from './types';
import { Connectable, TConnectableProps } from '../Connectable.hoc';
import { compose } from 'redux';
import GroupsList from '../_shared/GroupsList';
import { usePrivileges } from '@/app/state/auth/index.hooks';
import { useHistory } from 'react-router-dom';
import { RouteTankEditPage } from '@/app/pages/paths';

interface IProps {
    fuelTank: IFuelTank;
    onSend?: (fuelTank: IFuelTank) => void;
}

type TProps = IProps & TConnectableProps;

const FuelTankRow: FC<TProps> = ({ fuelTank, onSend, showFuelTankDialog }) => {
    const userPrivileges = usePrivileges();
    const history = useHistory();

    const handleSendClick = () => {
        if (onSend) {
            onSend(fuelTank);
        }
    };

    const handleEditClick = () => {
        if (userPrivileges.newTankEditionPage) {
            history.push(
                RouteTankEditPage.replace(
                    ':id',
                    fuelTank.externalId.toString()
                ) +
                    `?returnUrl=${encodeURIComponent(
                        history.location.pathname + history.location.search
                    )}`
            );
        } else {
            showFuelTankDialog({ fuelTank });
        }
    };

    const renderGroups = () => {
        const groups = fuelTank.groups;
        if (groups) {
            return <GroupsList groups={groups} />;
        }
        return null;
    };

    const {
        name,
        capacity,
        reserve,
        tareWeight,
        logicType,
        fuelType,
        description,
        monitoredId,
        timeZone,
    } = fuelTank;

    const logicDisplayName =
        logicType === REVERSED_LOGIC
            ? Translator.translate('Reversed')
            : Translator.translate('Simple');

    const columns = [
        name,
        (capacity || 0).toFixed(0),
        (reserve || 0).toFixed(0),
        (tareWeight || 0).toFixed(0),
        logicDisplayName,
        renderGroups(),
        fuelType,
        description,
        timeZone && timeZone.name,
        // eslint-disable-next-line react/jsx-key
        [
            <button
                key={'edit'}
                className="button button-link"
                onClick={handleEditClick}
            >
                <span className="icon icon-pencil2" />
                {Translator.translate('Edit')}
            </button>,

            monitoredId && (
                <button
                    key={'send'}
                    className="button button-link"
                    onClick={handleSendClick}
                >
                    <span className="icon icon-export-cards" />
                    {Translator.translate('Synchronize cards')}
                </button>
            ),
        ],
    ];

    return (
        <tr>
            {columns.map((column, index) => (
                <td key={index} className="column">
                    {column}
                </td>
            ))}
        </tr>
    );
};

export default compose(Connectable)(FuelTankRow);
